import React from 'react';
import { TableRow, TableCell, Skeleton } from '@mui/material';

const TableSkeletons = (props) => {
    const { headerLength } = props;

    return (
        <>
            {[...Array(5).fill('')].map(() => (
                <TableRow
                    hover
                    sx={{ height: '45px', width: '100%' }}
                    tabIndex={-1}
                    key={`loading-${Math.random()}`}
                >
                    {[...Array(headerLength).fill('')].map((column, i) => (
                        <TableCell
                            component="th"
                            id={'skeleton' + i}
                            key={`skeleton-${i}`}
                            scope="row"
                        >
                            <Skeleton />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    );
};

export default TableSkeletons;
